<template>
    <transition name="popup-fade">
        <div v-show="visible" class="email-popup-overlay" @click.self="closePopup">
            <div class="email-popup-modal">
                <div class="popup-image-col">
                    <img :src="imageSrc" alt="Join Mailing List" />
                </div>
                <button class="close-btn" @click="closePopup">[Close]</button>
                <div class="popup-content-col">
                    <div class="content-wrapper">
                        <p style="font-size: 16rem; padding-bottom: 20rem;">Don't be a stranger.</p>
                        <p class="subtitle" style="margin-bottom: 0rem;">New pieces, studio happenings,</p>
                        <p class="subtitle">and the occasional bit of nonsense.</p>

                        <form @submit.prevent="submitEmail" class="email-form">
                            <div class="input-group">
                                <input
                                    type="email"
                                    id="email"
                                    v-model="email"
                                    class="email-input"
                                    placeholder="Your Email Address"
                                    :disabled="submitting"
                                    required
                                />
                            </div>

                            <div class="submit-wrapper">
                                <button type="submit" class="submit-btn" :disabled="submitting">
                                    {{ submitting ? 'Submitting...' : '[Submit]' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import founderImg from '@/assets/mobile/email_bg.png'
import { subscribeEmail } from '@/api/content'
import { showMessage } from '@/config/message'

export default {
    name: 'MobileEmailPopup',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        autoShowDelay: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            email: '',
            imageSrc: founderImg,
            submitting: false,
            autoTimer: null
        }
    },
    watch: {
        visible(val) {
            if (!val) {
                this.$emit('close')
                this.$emit('update:visible', false)
            }
        }
    },
    mounted() {
        // 自动显示逻辑（如果有）
        if (this.autoShowDelay > 0 && !this.visible) {
            this.autoTimer = setTimeout(() => {
                if (!this.visible) {
                    this.$emit('update:visible', true)
                }
            }, this.autoShowDelay)
        }
        window.addEventListener('open-email-popup', this.openPopupByEvent)
    },
    beforeDestroy() {
        if (this.autoTimer) clearTimeout(this.autoTimer)
        window.removeEventListener('open-email-popup', this.openPopupByEvent)
    },
    methods: {
        openPopupByEvent() {
            this.$emit('update:visible', true)
        },
        closePopup() {
            if (this.autoTimer) {
                clearTimeout(this.autoTimer)
                this.autoTimer = null
            }
            this.$emit('update:visible', false)
            this.$emit('close')
        },
        async submitEmail() {
            if (this.submitting) return

            if (!this.email || this.email.trim() === '') {
                showMessage('Please fill out this field.', 'error')
                return
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.email)) {
                showMessage('Please enter a valid email address.', 'error')
                return
            }

            this.submitting = true

            try {
                const response = await subscribeEmail(this.email)
                if (response && response.retCode === 1) {
                    showMessage('Thank you for joining our mailing list!', 'success')
                    this.closePopup()
                    this.email = ''
                } else {
                    showMessage(response.retMsg || 'Subscription failed', 'error')
                    this.closePopup()
                }
            } catch (error) {
                console.error('Subscription error:', error)
                showMessage('An error occurred. Please try again.', 'error')
            } finally {
                this.submitting = false
            }
        }
    }
}
</script>

<style scoped>
/* ===== 过渡动画 ===== */
.popup-fade-enter-active,
.popup-fade-leave-active {
    transition: opacity 0.4s ease, transform 0.4s ease;
}
.popup-fade-enter-from,
.popup-fade-leave-to {
    opacity: 0;
    transform: scale(0.95);
}
.popup-fade-enter-to,
.popup-fade-leave-from {
    opacity: 1;
    transform: scale(1);
}

/* 遮罩背景和模糊的过渡 */
.popup-fade-enter-from .email-popup-overlay,
.popup-fade-leave-to .email-popup-overlay {
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
    background-color: rgba(255, 255, 255, 0);
}
.popup-fade-enter-to .email-popup-overlay,
.popup-fade-leave-from .email-popup-overlay {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    background-color: rgba(255, 255, 255, 0.6);
}

/* ===== 其余样式保持不变 ===== */
.close-btn {
    position: absolute;
    top: 11rem;
    left: 50%;
    transform: translateX(-50%);
    background: none;
    border: none;
    font-size: 13rem;
    cursor: pointer;
    line-height: 1;
    color: #000;
    padding: 5rem;
    font-weight: 500;
    font-family: 'Apercu', sans-serif !important;
}

.email-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    z-index: 20001;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20rem;
}

.email-popup-modal {
    background-color: #fff;
    width: 100%;
    max-width: 305rem;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10rem 40rem rgba(0,0,0,0.2);
    overflow: hidden;
    border: 1px solid #000000;
    position: relative;
}

.popup-image-col {
    width: 100%;
    height: 210rem;
    background-color: #f5f5f5;
    position: relative;
}

.popup-image-col img {
    width: 100%;
    height: 210rem;
    object-fit: cover;
    display: block;
}

.popup-content-col {
    width: 100%;
    padding: 20rem 30rem;
    padding-top: 40rem;
    background: #fff;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    font-family: 'Apercu', sans-serif !important;
}

.subtitle {
    font-size: 13rem;
    color: #888;
    margin-bottom: 60rem;
    text-align: center;
    font-weight: 400;
    max-width: 240rem;
}

.email-form {
    width: 100%;
}

.input-group {
    margin-bottom: 10rem;
    width: 100%;
}

.email-input {
    width: 100%;
    border: none;
    border-bottom: 1rem solid #000;
    padding: 10rem 0;
    font-size: 13rem;
    outline: none;
    font-family: 'Apercu', sans-serif !important;
    background: transparent;
    color: #000;
    border-radius: 0;
}

.email-input::placeholder {
    color: #000;
    font-family: 'Apercu', sans-serif !important;
    opacity: 1;
}

.submit-wrapper {
    text-align: center;
    margin-top: 20rem;
}

.submit-btn {
    background: none;
    border: none;
    font-size: 13rem;
    font-weight: 600;
    cursor: pointer;
    color: #000;
    padding: 10rem 20rem;
    font-family: 'Apercu', sans-serif !important;
}
</style>